import { inject, InjectionToken, NgZone } from "@angular/core";
import { BroadcastService } from "@app/core";

export const SESSION_BROADCAST_SERVICE = new InjectionToken<BroadcastService>("broadCastService", {
  factory: () => new BroadcastService("session-channel", inject(NgZone))
});
